import { render, staticRenderFns } from "./boq-import-takeoff-modal.vue?vue&type=template&id=57964bca"
import script from "./boq-import-takeoff-modal.vue?vue&type=script&lang=js"
export * from "./boq-import-takeoff-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports